
let xmlReducer = function(xml = null, action) {
    switch (action.type) {
        case 'GET_ALLOCATION_AVAILABILITY_XML_REQUEST_BEGIN':
            return action.xml;
        case 'GET_ALLOCATION_AVAILABILITY_XML_REQUEST_END':
            return action.xml;
        case 'GET_HOTEL_AVAILABILITY_XML_REQUEST_BEGIN':
            return action.xml;
        case 'GET_HOTEL_AVAILABILITY_XML_REQUEST_END':
            return action.xml;
        case 'CLEAR_XML_REQUEST':
            return action.xml;
        default:
            return xml;
    }
};

export default xmlReducer;